// Custom dropdown handler
document.body.addEventListener('click', function (evt) {
	if (!evt.target.closest('.dropdown'))
		return;

	evt.target.closest('.dropdown').classList.toggle('--open');
});

document.querySelectorAll('.dropdown').forEach((elem, idx) => {
	// Apertura all'hover solo per menu principale
	if (elem.closest('#main-menu-container')) {
		elem.addEventListener('mouseenter', function (evt) {
			evt.target.closest('.dropdown').classList.add('--open');
		});
	}

	elem.addEventListener('mouseleave', function (evt) {
		evt.target.closest('.dropdown').classList.remove('--open');
	});
});

document.querySelectorAll('.dropdown__options ul li a').forEach((elem, idx) => {
	elem.addEventListener('click', function (evt) {
		evt.target.closest('.dropdown__options ul').querySelectorAll('li.--selected').forEach( (i) => {
			i.classList.remove('--selected');
		});
		
		evt.target.closest('li').classList.add('--selected');

		if (document.body.classList.contains('--flyout-open')) {
			document.body.classList.remove('--flyout-open')
		}
	});
});

